import React from 'react';
import { IconButton, Tooltip, Stack } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { Intervention } from '@/types';

interface InterventionActionsProps {
  intervention: Intervention;
  onEdit: () => void;
  onDelete: (id: string) => void;
}

export const InterventionActions: React.FC<InterventionActionsProps> = ({
  intervention,
  onEdit,
  onDelete
}) => {
  return (
    <Stack direction="row" spacing={1}>
      <Tooltip title="Edit intervention">
        <IconButton
          size="small"
          onClick={onEdit}
          sx={{ 
            color: 'primary.main',
            '&:hover': {
              bgcolor: 'primary.lighter'
            }
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete intervention">
        <IconButton
          size="small"
          onClick={() => onDelete(intervention.id)}
          sx={{ 
            color: 'error.main',
            '&:hover': {
              bgcolor: 'error.lighter'
            }
          }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};